import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../../Button'
import { ICON_HEIGHT_24 } from '../../../Icon'

import * as styles from './RentalPortalProfileHeaderFooterActionButton.module.css'

function RentalPortalProfileHeaderFooterActionButton({
  Icon,
  disabled,
  qaName,
  text,
  tooltipKey,
  wrapperRef,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <div
      className={styles.RentalPortalProfileHeaderFooterActionButton}
      ref={wrapperRef}
    >
      <Button.Text
        beforeIconProps={{ Icon, height: ICON_HEIGHT_24 }}
        className={styles.button}
        disabled={disabled}
        height={BUTTON_HEIGHT_40}
        isGrey={disabled}
        isInline={false}
        qaName={qaName}
        showTextTooltip={!disabled}
        text={text}
        tooltip={disabled ? t(tooltipKey) : null}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        onClick={onClick}
      />
    </div>
  )
}

export default RentalPortalProfileHeaderFooterActionButton
